export default __webpack_public_path__ + "static/media/480_business05-fr-web.6b77ab3b.png";